import { render, staticRenderFns } from "./MinisiteTransferFiles.vue?vue&type=template&id=db06a1da&scoped=true&"
import script from "./MinisiteTransferFiles.vue?vue&type=script&lang=js&"
export * from "./MinisiteTransferFiles.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteTransferFiles.vue?vue&type=style&index=0&id=db06a1da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db06a1da",
  null
  
)

export default component.exports